<template>
  <v-container id="dashboard-stats-grid" :class="compact ? 'mt-4 pt-2' : 'mt-6 pt-6'" style="max-width: 1280px;">
    <v-row class="py-4" style="margin: 0 -8px;">
      <v-col cols="6" sm="4" md="2" v-for="(stat, index) in statCards" :key="index" style="padding: 8px;">
        <v-card 
          class="stat-card"
          :class="{ 'stat-card-clickable': stat.isClickable }"
          :data-stat-key="stat.navTabKey"
          elevation="0" 
          :style="`border: 1px solid #e5e7eb; background-color: white; border-radius: 8px; height: 100%; ${stat.isClickable ? 'cursor: pointer;' : ''}`"
          @click="stat.isClickable && $emit('navigate', stat.navTabKey)">
          <v-card-text class="pa-5">
            <div class="d-flex justify-space-between align-start mb-3">
              <div :style="`padding: 8px; display: flex; align-items: center; justify-content: center; background-color: ${stat.bgColor}; border-radius: 8px;`">
                <v-icon :color="stat.iconColor" size="20">{{ stat.icon }}</v-icon>
              </div>
              <v-chip v-if="stat.badge" x-small :color="stat.badgeColor" dark class="font-weight-bold" style="height: 18px; font-size: 10px;">
                {{ stat.badge }}
              </v-chip>
            </div>
            <div class="text-h5 font-weight-bold mb-1" style="color: #1f2937;">{{ stat.value }}</div>
            <div class="text-body mb-1" style="color: #6b7280; font-weight: 500; font-size: 13px;">{{ stat.label }}</div>
            <div 
              v-if="stat.subtext" 
              class="text-body" 
              :style="`color: ${stat.subtextColor || '#6b7280'}; font-weight: 500; font-size: 11px;`">
              {{ stat.subtext }}
              <v-icon 
                v-if="stat.showSubtextAlert"
                size="14"
                class="ml-1"
                color="#b71c1c"
              >
                mdi-alert-circle
              </v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'DashboardStatsGrid',
  
  props: {
    statCards: {
      type: Array,
      required: true,
      default: () => []
    },
    compact: {
      type: Boolean,
      default: false,
    },
  }
};
</script>

<style scoped>
.stat-card {
  transition: all 0.3s ease;
}

/* Original hover effect */
/* .stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
} */

.stat-card:not(.stat-card-clickable):hover { 
  box-shadow: none !important; 
  transform: none !important; 
}

.stat-card-clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.stat-card-clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  border-color: #ff1463 !important;
}
</style>
